import React from 'react'
import WizardStepBase from '../base'
import { Link, withRouter } from 'react-router-dom'
import SizeBox from 'app/components/size_box'
import CustomSizeBox from 'app/components/custom_size_box'
import constants from '../../../constants'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Img1 from 'assets/images/icons/options/open1.png'
import Img2 from 'assets/images/icons/options/open2.png'
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import * as orderActions from '../../../actions/order_actions';
import _ from 'lodash';

import HTMLEllipsis from 'react-lines-ellipsis/lib/html'
import LinesEllipsis from 'react-lines-ellipsis'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'

const ResponsiveEllipsis = responsiveHOC()(HTMLEllipsis)
import OpenType from 'app/components/open_type'

class WizardStepTwo extends WizardStepBase {
  constructor(props) {
    super(props);
    this.stepNum = 2;
    this.state = {
      fullText: false
    }
  }

  renderRequiredOprions() {
    let options = [],
      required = _.get(this.props.constructions_state, 'selected_type.construction_type_options', {});
    for(let key in required) {
      if (required[key] === true && constants.PART_TITLES[key]) {
        options.push(constants.PART_TITLES[key]);
      }
    }

    return options;
  }

  openTypes() {
    const types = [{id: 1, title: 'левая', img: Img1},
                   {id: 2, title: 'правая', img: Img2}];

    return types.map((item) => {
      return (
        <OpenType item={item}
                  key={item.id}
                  selected_open={this.props.order_state.groups.open.item}
                  onOpenTypeSelected={this.props.order_actions.openTypeSelected}
        />
      );
    });
  }

  toggleText = (e) => {
    e.preventDefault();
    this.setState({
      fullText: !this.state.fullText
    });
  };


  render() {
    let
      req = this.renderRequiredOprions().join(', '),
      defaultHelp = "\<b>Текст о том, как правильно измерить дверь.\</b> Потому что некоторые померяют рулеткой проем он у них 1030мм они так и забивают в калькулятор, пугаются суммы и не делают заказ. А на самом деле в его проем встанет стандартная дверь и ему не надо переплачивать.",
      helpText = _.get(appConfig.text_zones, 'sizes_help', defaultHelp);

    return (
      <div>
        <h1>Размеры<span className="required-option">обязательно</span></h1>
        <div className='wizard-tooltip with-icon- sizes-'>
          {
            this.state.fullText ? (
              <div dangerouslySetInnerHTML={{__html: helpText}} />
            ) : (
              <ResponsiveEllipsis
                unsafeHTML={helpText}
                maxLine='2'
                ellipsis='...'
                basedOn='letters'
              />
            )
          }
          <div className="toggler-wrapper">
            <span className="toggler" onClick={this.toggleText}>{ !this.state.fullText ? 'Показать полностью' : 'Свернуь' }</span>
          </div>

          { req.length ? (
              <React.Fragment>
                <br />
                При выборе заводского стандарта в заказ, для выбранной Вами конструкции необходимо будет добавить: <span className="red-">{this.renderRequiredOprions().join(', ')}</span>.
              </React.Fragment>
            ) : null
          }
        </div>

        <div className='wizard-screen screen-2'>
          <div className='wizard-screen-row'>
            <div className='wizard-screen-cell cell-1-2'>
              <SizeBox
                sizes={_.get(this.props, 'constructions_state.selected_type.sizes')}
                onGroupSelected={this.props.order_actions.selectGroup}
                sizeSelected={this.props.order_actions.sizeSelected}
                orderState={this.props.order_state.groups}
              />
            </div>
            <div className='wizard-screen-cell cell-1-2'>
              <CustomSizeBox
                sizes={_.get(this.props, 'constructions_state.selected_type.custom_sizes')}
                onGroupSelected={this.props.order_actions.selectGroup}
                orderState={this.props.order_state.groups}
              />
            </div>
          </div>
          <div className='wizard-screen-row'>
            <div className='wizard-screen-cell cell-1-2'>
              <div className='wizard-block-form unselectable-'>
                <div className='selectable-block-title'>
                  Сторона открывания
                  <span className="required-option">обязательно</span>
                </div>
                <div className='help-box left-arrow mobile-show'><b>Сторонность петель определяется, </b>
                  стоя лицом к входу в закрываемое помещение,
                  с уличной стороны двери
                </div>
                <div className='form'>
                  <div className='form-row inline- two-cols-'>
                    { this.openTypes() }
                  </div>
                </div>
              </div>
            </div>
            <div className='wizard-screen-cell cell-1-2 mobile-hidden'>
              <div className='help-box left-arrow'><b>Сторонность петель определяется,</b>
                стоя лицом к входу в закрываемое помещение,
                с уличной стороны двери
              </div>
            </div>
          </div>
        </div>

        <div className="mobile-show">
          <Link className='back-link' onClick={this.stepChange} to={constants.ROUTES.HOME}>Вернуться к выбору конструкции</Link>
        </div>
        <Link onClick={this.stepChange} className='button button-red button-large wizard-next-action-button' to={constants.ROUTES.STEP3}>
          <span>перейти к внешнему виду</span>
        </Link>
        <div className="mobile-hidden">
          <Link className='back-link' to={constants.ROUTES.HOME}>Вернуться к выбору конструкции</Link>
        </div>
        {this.renderConfirm()}
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    constructions_state: state.constructionsState,
    order_state: state.orderState,
    app: state.applicationState
  }
};

const mapDispatch = (dispatch) => {
  return {
    order_actions: bindActionCreators(orderActions, dispatch)
  };
};

export default withRouter(connect(mapStateToProps, mapDispatch, null, {pure: false})(WizardStepTwo));



// WEBPACK FOOTER //
// ./app/javascript/app/pages/wizard_steps/step_2/index.jsx